export default class VideoAdsException extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'VideoAdsException';
  }
}
